import type { ReactNode } from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';

/** Card with a heading row (title, optional description and actions). */
export function SectionCard({
  title,
  description,
  actions,
  children,
  noPadding,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  noPadding?: boolean;
}) {
  return (
    <Card>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        sx={{
          px: 2.5,
          py: 2,
          alignItems: { sm: 'center' },
          justifyContent: 'space-between',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Stack spacing={0.25}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          {description && (
            <Typography
              variant="body2"
              color="text.secondary"
              // Rich descriptions (chips, links in a stack) cannot live inside a <p>.
              component={typeof description === 'string' ? 'p' : 'div'}
            >
              {description}
            </Typography>
          )}
        </Stack>
        {actions && (
          <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
            {actions}
          </Stack>
        )}
      </Stack>
      {noPadding ? children : <CardContent>{children}</CardContent>}
    </Card>
  );
}
